document.addEventListener("DOMContentLoaded", function () {
  const accItems = document.querySelectorAll(".block__our-workflow-acc-item");

  accItems.forEach(item => {
    const answer = item.querySelector(".block__our-workflow-acc-answer");

    // Initialize
    answer.style.maxHeight = "0px";
    answer.style.overflow = "hidden";
    answer.style.transition = "max-height 0.4s ease";

    item.addEventListener("click", function () {
      accItems.forEach(otherItem => {
        const otherAnswer = otherItem.querySelector(".block__our-workflow-acc-answer");
        if (otherItem !== item) {
          otherAnswer.style.maxHeight = "0px";
          otherItem.classList.remove("active");
        }
      });

      const isOpen = item.classList.contains("active");

      if (!isOpen) {
        answer.style.maxHeight = answer.scrollHeight + "px";
        item.classList.add("active");
      } else {
        answer.style.maxHeight = "0px";
        item.classList.remove("active");
      }
    }); 
  });

  // ✅ Open the first item by default
  const firstItem = accItems[0];
  const firstAnswer = firstItem.querySelector(".block__our-workflow-acc-answer");

  firstAnswer.style.maxHeight = firstAnswer.scrollHeight + "px";
  firstItem.classList.add("active");
});
